const isEnabledFeature = key => {
  return key === 'true'
}

function hasFeatureFlag (allowedFeatureFlags, flag) {
  return allowedFeatureFlags?.includes(flag) ?? false
}

export {
  hasFeatureFlag,
  isEnabledFeature
}
